import { StorageType } from '@incentivegames/ig-types/lib/enums/storage/storageType';
import { IGameConfiguration, OddsType } from 'interfaces/configurationInterfaces';

import InputSource from '@incentivegames/ig-types/lib/constants/communication/inputSource.js';
//used with story book to populate dropdown
export type SupportedLanguages = typeof supportedLanguages[number];
export const supportedLanguages = [
  'en-GB',
  'zh-CN',
  'zh',
  'sv',
  'sk',
  'ru',
  'ro',
  'pt-BR',
  'pt',
  'pl',
  'nl',
  'nb',
  'ja',
  'it',
  'hu',
  'fr',
  'et',
  'es-MX',
  'es',
  'es-LA',
  'en-US',
  'en-AU',
  'el',
  'da',
  'de',
  'cz',
  'bg',
] as const;

export type SupportedCurrencies = typeof supportedCurrencies[number];
export const supportedCurrencies = [
  'ARS',
  'AUD',
  'BDT',
  'BGN',
  'BRL',
  'CAD',
  'CHF',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'GHS',
  'HKD',
  'HUF',
  'INR',
  'ISK',
  'JPY',
  'MXN',
  'MYR',
  'NOK',
  'NZD',
  'PLN',
  'RMB',
  'PEN',
  'RSD',
  'RON',
  'RUB',
  'SEK',
  'SGD',
  'THB',
  'TWD',
  'TZS',
  'USD',
  'ZAR',
] as const;
const gameConfigurations: IGameConfiguration[] = [
  {
    predictorIdIdentifier: 'IncentiveID',
    id: 'game',
    settings: {
      //gameTitle
      gameTitleIdentifier: 'gametitle',
      countryCodeIdentifier: 'countrycode',
      countryRegionCodeIdentifier: 'statecode',

      // Token Config
      tokenFromParentType: InputSource.URL,
      tokenCookieName: 'token',

      // Locale Config
      defaultLocale: '',

      // Language Config
      languageFromParentType: InputSource.URL,
      languageCodeIdentifier: 'language',
      defaultLanguage: 'en-GB',
      fallbackLanguage: 'en-GB',
      supportedLanguages: [...supportedLanguages],

      // Currency Config
      defaultCurrency: 'USD',
      currencyFromParentType: InputSource.URL,
      currencyCodeIdentifier: 'currency',
      oddsTypeIdentifier: 'oddstype',
      supportedCurrencies: [...supportedCurrencies],
      currenciesToBeReversed: ['da', 'el', 'cz', 'pt'],
      // Storage Config
      storageType: StorageType.localStorage,

      feedProvider: 'bet365',
      getUserOddsPreference: (oddsType): OddsType => {
        switch (oddsType) {
          case 'fraction':
            return 'fractional';
          case 'decimal':
            return 'decimal';
          case 'american':
            return 'american';
          default:
            return 'fractional';
        }
      },
    },
  },
];

export default gameConfigurations[0];
